import { FC } from "react";
import {
  CircleDollarSignIcon,
  Clock5Icon,
  LockKeyholeIcon,
} from "lucide-react-native";

import PointCareSmallLogo from "@/assets/images/favicon.png";
import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { OnboardingScreenType } from "@/domain/onboarding";
import { useOnboardingBenefitsContent } from "@/hooks/useOnboardingBenefitsContent";

import benefitsBackground from "./assets/benefits-background.jpg";
import { PhotoCardHeader } from "./PhotoCardHeader";
import { PhotoCardRow } from "./PhotoCardRow";
import { PhotoCardStepFrame } from "./PhotoCardStepFrame";

const IMAGE_POSITION = { left: "45%", top: "40%" } as const;

export const PhotoCardBenefitsStep: FC<OnboardingScreenType> = layout => {
  const { title, description, firstItem, freeToUse, infoIsPrivate } =
    useOnboardingBenefitsContent();

  return (
    <PhotoCardStepFrame
      {...layout}
      image={benefitsBackground}
      imagePosition={IMAGE_POSITION}>
      <PhotoCardHeader
        icon={
          <VnImage
            source={PointCareSmallLogo}
            className="h-12 w-12 rounded-md"
            contentFit="cover"
          />
        }
        title={title}
        description={description}
      />

      <VnBox className="gap-3">
        <PhotoCardRow icon={Clock5Icon} text={firstItem} />
        <PhotoCardRow icon={CircleDollarSignIcon} text={freeToUse} />
        <PhotoCardRow icon={LockKeyholeIcon} text={infoIsPrivate} />
      </VnBox>
    </PhotoCardStepFrame>
  );
};
